import { createRoot } from 'react-dom/client';
import '@/index.css';
import { ReportSnapshotWrapper } from '@/features/report-snapshots/components/report-snapshot-wrapper';
import * as Sentry from '@sentry/react';
import { sentryConfig } from '@/lib/sentry';
import { getQueryClient } from '@/lib/query-client';
import { StrictMode } from 'react';
import { Providers } from '@/app/providers';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useTheme as useBridgeTheme } from '@/hooks/bridge';

Sentry.init(sentryConfig);

const root = document.getElementById('root');
if (!root) throw new Error('No root element found');

const queryClient = getQueryClient();

export function ReportSnapshotApp() {
  const theme = useBridgeTheme();
  return (
    <StrictMode>
      <Providers queryClient={queryClient} theme={theme}>
        <ReportSnapshotWrapper />
        <ReactQueryDevtools initialIsOpen={false} />
      </Providers>
    </StrictMode>
  );
}

createRoot(root).render(<ReportSnapshotApp />);
